"use client";
import { useState } from "react";

interface FloatingTitleProps {
  text: string;
  classname: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?: any
}

export default function FloatingTitle({ text, classname, ref }: FloatingTitleProps) {
  const letters = text.split("");
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);


  return (
    <h1 className={classname} ref={ref}>
      {letters.map((letter, i) => (
        <span
          key={i}
          className={`inline-block transition-transform duration-200 ${
            hoveredIndex === i ? "translate-y-[-5px] rotate-[-5deg]" : ""
          }`}
          onMouseEnter={() => setHoveredIndex(i)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          {letter}
        </span>
      ))}
    </h1>
  );
}
